import { render } from "./freezed.vue?vue&type=template&id=2fbaf0b4"
import script from "./freezed.vue?vue&type=script&lang=js"
export * from "./freezed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__